import React, { useState } from 'react';
import styles from './vacancyConfigurations.module.scss';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { CustomButton } from '../../../../shared/customButton';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomDropdown } from '../../../../shared/customDropdown';
import { Formik } from 'formik';
import * as yup from 'yup';
import { CustomTextEditor } from '../../../../shared/customTextEditor';
var currencyCodes = require('currency-codes');

const AddPipelineVacancyConfigurations = (props) => {

    let [description_body_html, setDescriptionBodyHtml] = useState(props.pipelineValues.description);
    let contentState = '';

    const
        dropValue = [
            {
                label: 'Full-Time',
                value: 10,
            },
            {
                label: 'Part-Time',
                value: 20,
            },
            {
                label: 'Contract/ Temp',
                value: 30,
            },
            {
                label: 'Casual/ Vacation',
                value: 40,
            },
            {
                label: 'Internship',
                value: 50,
            },
        ]
    const
        dropValueSalary = [
            {
                label: 'Hourly',
                value: 10,
            },
            {
                label: 'Daily',
                value: 20,
            },
            {
                label: 'Weekly',
                value: 30,
            },
            {
                label: 'Fortnight',
                value: 40,
            },
            {
                label: 'Monthly',
                value: 50,
            },
        ]
    const
        dropValueMobility = [
            {
                label: 'Remote',
                value: 10,
            },
            {
                label: 'On-Site',
                value: 20,
            },
            {
                label: 'Hybrid',
                value: 30,
            },
        ]

    let currencyCodeDropdownArray = []
    let currencyCodeArray = currencyCodes.codes()

    for (let index = 0; index < currencyCodeArray.length; index++) {
        let currency_code_object = {
            label: currencyCodeArray[index],
            value: currencyCodeArray[index]
        }

        currencyCodeDropdownArray.push(currency_code_object)
    }


    //yup validations
    const schema = yup.object({
        jobMobility: yup.number().required('Required'),
        jobType: yup.number().required('Required'),
        paidCurrency: yup.string().required('Required'),
        salaryPaidBy: yup.number().required('Required'),
        location: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60'),
        position: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60').required('Required'),
        vacancyDesc: yup.string()
            .required('Required')
            .test('email body check', 'Required', function (item) {
                let strippedHtml = item.replace(/<[^>]+>/g, '');
                return strippedHtml.trim().length > 0;
            })
            .required('Required'),

    });

    //on submit function
    const onSubmit = async (values) => {
        props.setPipelineDetails(values)
        props.nextPage(3)
    }
      
    const removeTextDecoration = (htmlContent) => {
        let noDecoration = htmlContent.replace(/<span style="text-decoration: (underline|line-through|overline);[^>]*>(.*?)<\/span>/gi, '$2');
        noDecoration = noDecoration.replace(/<span style="background-color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        noDecoration = noDecoration.replace(/<span style="color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        let withFont = noDecoration.replace(/(<span[^>]*>)(<\/span>)/gi, (match, opening, closing) => {
            if (opening) {
                return opening + ' style="font-family: Inter, sans-serif; font-size: 12px;"' + closing;
            } else {
                return closing;
            }
        });
    
        // Set font family and size to Inter, sans-serif; font-size: 16px for all heading tags
        const headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
        headings.forEach(tag => {
            const regex = new RegExp(`<${tag}[^>]*>(.*?)</${tag}>`, 'gi');
            withFont = withFont.replace(regex, (match, content) => {
                return `<h3 style="font-family: Inter, sans-serif; font-size: 16px !important;">${content}</h3>`;
            });
        });
    
        return withFont;
    };
    
    
    return (
        <div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <Formik
                            validationSchema={schema}
                            onSubmit={(values) => onSubmit(values)}
                            initialValues={{ vacancyDesc: props.pipelineValues.description, position: props.pipelineValues.hiring_position_label, jobType: props.pipelineValues.jobType, jobMobility: props.pipelineValues.jobMobility, paidCurrency: props.pipelineValues.paidCurrency, salaryPaidBy: props.pipelineValues.salaryPaidBy, location: props.pipelineValues.location }}>
                            {({
                                values,
                                errors,
                                setFieldValue,
                                handleChange,
                                handleSubmit,
                                submitCount
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Row>

                                        <Col className={styles.pipelineConfigurationsCol}>
                                            <CustomTextField
                                                label="Position"
                                                classLabel="defaultLabel"
                                                controlId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_positionFieldId"
                                                placeholder="ex:- Software Engineer"
                                                type="text"
                                                value={values.position}
                                                name="position"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                maxlength={60}
                                                errorMessage={errors.position}
                                                validationMessageId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_positionValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.position}
                                            />

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsDescriptionCol}>
                                            <Form.Label className={styles.defaultLabel}>
                                                Job Description
                                            </Form.Label>
                                            <div className={submitCount > 0 && errors.vacancyDesc ? styles.descriptionBodyError : ''}>
                                                <CustomTextEditor
                                                value = {description_body_html}
                                                handleOnChange={(e) => {
                                                    setDescriptionBodyHtml(e);
                                                    setFieldValue('vacancyDesc', removeTextDecoration(e));
                                                }}
                                                />
                                            </div>
                                            {submitCount > 0 && errors.vacancyDesc &&
                                                <p className={styles.errorLabel} id="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_vacancyDescFieldId">{errors.vacancyDesc}</p>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsCol}>
                                            <CustomDropdown
                                                label="Job Type"
                                                controlId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_jobTypeDropdownId"
                                                name="jobType"
                                                value={values.jobType}
                                                handleOnChange={(e) => { setFieldValue('jobType', parseInt(e.target.value)); }}
                                                dropdownValues={dropValue}S
                                                errorMessage={errors.jobType}
                                                validationMessageId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_jobTypeValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.jobType}
                                                hiddenOption="Select Job Type"
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsCol}>
                                            <CustomDropdown
                                                label="Work Type"
                                                controlId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_workTypeDropdownId"
                                                name="jobMobility"
                                                value={values.jobMobility}
                                                handleOnChange={(e) => {
                                                    setFieldValue('jobMobility', parseInt(e.target.value));
                                                    // changeType(e.target.value)
                                                }}
                                                dropdownValues={dropValueMobility}
                                                errorMessage={errors.jobMobility}
                                                validationMessageId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_workTypeValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.jobMobility}
                                                hiddenOption="Select Work Type"
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsCol}>
                                            <CustomTextField
                                                label="Location"
                                                classLabel="defaultLabel"
                                                controlId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_locationDropdownId"
                                                placeholder="ex:- Colombo, Sri Lanka"
                                                type="text"
                                                value={values.location}
                                                name="location"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                maxlength={60}
                                                errorMessage={errors.location}
                                                validationMessageId="adminPanel_hiringPipelines_createPipelineModal_vacancuConfigurations_locationValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.location}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='mt-2'>
                                        <Col  sm={6} className={styles.pipelineConfigurationsCol}>
                                            <CustomDropdown
                                                label="Paid Currency"
                                                controlId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_paidCurrencyDropdownId"
                                                name="paidCurrency"
                                                value={values.paidCurrency}
                                                handleOnChange={(e) => {
                                                    setFieldValue('paidCurrency', e.target.value);
                                                    // changeType(e.target.value)
                                                }}
                                                dropdownValues={currencyCodeDropdownArray}
                                                errorMessage={errors.paidCurrency}
                                                validationMessageId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_paidCurrencyValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.paidCurrency}
                                                hiddenOption="Select Currency"
                                            />
                                        </Col>
                                        <Col className='me-0' sm={6}>
                                            <CustomDropdown
                                                label="Salary Paid By"
                                                controlId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_salaryPaidByDropdownId"
                                                name="salaryPaidBy"
                                                value={values.salaryPaidBy}
                                                handleOnChange={(e) => {
                                                    setFieldValue('salaryPaidBy', parseInt(e.target.value));
                                                    // changeType(e.target.value)
                                                }}
                                                dropdownValues={dropValueSalary}
                                                errorMessage={errors.salaryPaidBy}
                                                validationMessageId="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_salaryPaidByValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.salaryPaidBy}
                                                hiddenOption="Select Salary Paid By"
                                            />
                                        </Col>
                                    </Row>
                                    <hr className={styles.dividerLine} />
                                    <Row className="mt-3  d-flex flex-row-reverse">
                                        <div className={styles.navigateBtnCol}>
                                            <CustomButton
                                                id="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_nextBtnId"
                                                buttonType="submit"
                                                label="Next"
                                                type="primaryBtn"
                                            />
                                        </div>
                                        <div className={styles.navigateBtnCol}>
                                            <CustomButton
                                                id="adminPanel_hiringPipelines_createPipelineModal_vacancyConfigurations_cancelBtnId"
                                                buttonType="button"
                                                label="Back"
                                                type="defaultBtn"
                                                handleClick={() => props.previousPage(1)}
                                            />
                                        </div>

                                    </Row>
                                </Form>
                            )}
                        </Formik>

                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default AddPipelineVacancyConfigurations;
